export const M1_UNIT_REVIEW = {
  id: "m1-final-review",
  title: "Review Master Módulo 1",
  topic: "Examen Final Integrado",
  iconType: "star",
  grammarImage: "/m1-final-review--master.jpg",
  grammarText: "¡Felicidades! Has llegado al final. Este repaso cubre TODO lo aprendido: desde 'Hello' hasta 'Daily Routines'.",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: SPEED VOCABULARY (Conceptos Básicos)
    // Enfoque: Agilidad mental.
    // ----------------------------------------------------------------------
    {
      id: "m1-final-review-s1",
      title: "Set 1: Speed Vocab",
      questions: [
        {
          type: "match",
          q: "Match Numbers",
          pairs: [
            { left: "12", right: "Twelve" },
            { left: "20", right: "Twenty" },
            { left: "100", right: "One hundred" }
          ],
          a: "completed"
        },
        { type: "mc", q: "My father's brother is my ___.", options: ["Uncle", "Cousin", "Grandpa"], a: "Uncle" },
        { type: "input", q: "Opposite of 'Day' is ___.", a: "Night" },
        { type: "mc", q: "I am from Japan. I am ___.", options: ["Japanese", "Japanish", "Japan"], a: "Japanese" },
        { type: "match",
          q: "Match Jobs",
          pairs: [
            { left: "Doctor", right: "Hospital" },
            { left: "Teacher", right: "School" },
            { left: "Farmer", right: "Farm" }
          ],
          a: "completed"
        },
        { type: "input", q: "Twelve months = One ___.", a: "year" },
        { type: "order", q: "Ordena", words: ["My", "name", "is", "Alex."], a: "My name is Alex." },
        { type: "mc", q: "Saturday and Sunday are the ___.", options: ["Weekend", "Weekdays", "Workdays"], a: "Weekend" },
        { type: "input", q: "The son of my sister is my ___.", a: "nephew" },
        { type: "match",
          q: "Time Words",
          pairs: [
            { left: "AM", right: "Morning" },
            { left: "PM", right: "Afternoon/Evening" },
            { left: "12:00 PM", right: "Noon" }
          ],
          a: "completed"
        }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: ERROR HUNT (Gramática)
    // Enfoque: Detectar y corregir errores típicos de A1.
    // ----------------------------------------------------------------------
    {
      id: "m1-final-review-s2",
      title: "Set 2: Find the Mistake",
      questions: [
        { type: "mc", q: "Incorrect: 'She have a cat'. Correct: ___", options: ["She has a cat", "She haves a cat"], a: "She has a cat" },
        { type: "mc", q: "Incorrect: 'I works in a bank'. Correct: ___", options: ["I work", "I working"], a: "I work" },
        { type: "input", q: "Correct: 'He don't like pizza' -> He ___ like pizza.", a: "doesn't" },
        { type: "match",
          q: "Fix the Preposition",
          pairs: [
            { left: "In Monday", right: "On Monday" },
            { left: "At the morning", right: "In the morning" },
            { left: "On 5:00", right: "At 5:00" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena (Correct)", words: ["Does", "she", "live", "here?"], a: "Does she live here?" },
        { type: "mc", q: "Incorrect: 'This are my books'. Correct: ___", options: ["These are my books", "This is my books"], a: "These are my books" },
        { type: "input", q: "Correct: 'My parents is happy' -> My parents ___ happy.", a: "are" },
        { type: "mc", q: "Incorrect: 'I am 20 years'. Correct: ___", options: ["I am 20 years old", "I have 20 years"], a: "I am 20 years old" },
        { type: "match",
          q: "Singular vs Plural",
          pairs: [
            { left: "One child", right: "Two children" },
            { left: "One man", right: "Two men" },
            { left: "One person", right: "Two people" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena (Correct)", words: ["I", "never", "drink", "coffee."], a: "I never drink coffee." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: TRANSLATOR (Español -> Inglés)
    // Enfoque: Construcción de frases completas.
    // ----------------------------------------------------------------------
    {
      id: "m1-final-review-s3",
      title: "Set 3: Translator",
      questions: [
        { type: "order", q: "Traduce: 'Ella es mi hermana.'", words: ["She", "is", "my", "sister."], a: "She is my sister." },
        { type: "input", q: "Traduce: 'Me gusta el fútbol.' -> I ___ soccer.", a: "like" },
        { type: "mc", q: "Traduce: '¿Dónde vives?'", options: ["Where do you live?", "Where are you live?", "Where you live?"], a: "Where do you live?" },
        { type: "order", q: "Traduce: 'Yo no trabajo los domingos.'", words: ["I", "don't", "work", "on", "Sundays."], a: "I don't work on Sundays." },
        { type: "match",
          q: "Translate Frequency",
          pairs: [
            { left: "Siempre", right: "Always" },
            { left: "A veces", right: "Sometimes" },
            { left: "Nunca", right: "Never" }
          ],
          a: "completed"
        },
        { type: "input", q: "Traduce: 'Son las tres y media.' -> It's ___ past three.", a: "half" },
        { type: "order", q: "Traduce: 'El perro de Tom es grande.'", words: ["Tom's", "dog", "is", "big."], a: "Tom's dog is big." },
        { type: "mc", q: "Traduce: 'Nosotros vamos al cine.'", options: ["We go to the cinema", "We go at the cinema"], a: "We go to the cinema" },
        { type: "input", q: "Traduce: 'Ella se levanta a las 7.' -> She ___ up at 7.", a: "gets" },
        { type: "order", q: "Traduce: '¿Tienes un coche?'", words: ["Do", "you", "have", "a", "car?"], a: "Do you have a car?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: READING FINAL - "A BUSY DAY"
    // Enfoque: Comprensión integrada.
    // ----------------------------------------------------------------------
    {
      id: "m1-final-review-s4",
      title: "Set 4: A Busy Day",
      questions: [
        {
          type: "mc",
          q: "READING:\n'My name is Lisa. I am a nurse at City Hospital. I work from Monday to Saturday. Sunday is my only free day.'\n\nQuestion: When is Lisa free?",
          options: ["Sunday", "Saturday", "Monday"],
          a: "Sunday"
        },
        {
          type: "blank",
          q: "READING:\n'I get up very early, at 5:30 AM. I have a quick breakfast and drive to work.'\n\nQuestion: She ___ to work.",
          a: "drives"
        },
        {
          type: "mc",
          q: "READING:\n'I work with doctors and patients. It is a hard job but I love it.'\n\nQuestion: Does she like her job?",
          options: ["Yes", "No"],
          a: "Yes"
        },
        {
          type: "match",
          q: "Lisa's Facts",
          pairs: [
            { left: "Job", right: "Nurse" },
            { left: "Place", right: "City Hospital" },
            { left: "Wake up", right: "5:30 AM" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["She", "works", "six", "days", "a", "week."], a: "She works six days a week." },
        {
          type: "mc",
          q: "READING:\n'In the evening, I cook dinner for my husband and my two children. We eat at 7:30 PM.'\n\nQuestion: Who does she cook for?",
          options: ["Her family", "Her friends", "Herself"],
          a: "Her family"
        },
        { type: "input", q: "Lisa has ___ (number) children.", a: "two" },
        { type: "match",
          q: "Evening Routine",
          pairs: [
            { left: "Activity", right: "Cook dinner" },
            { left: "Time", right: "7:30 PM" },
            { left: "Company", right: "Husband & Kids" }
          ],
          a: "completed"
        },
        { type: "blank", q: "Lisa is a ___ (occupation).", a: "nurse" },
        { type: "order", q: "Final thought", words: ["She", "loves", "her", "job."], a: "She loves her job." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: THE FINAL BOSS (Integration)
    // Enfoque: Demostrar dominio total.
    // ----------------------------------------------------------------------
    {
      id: "m1-final-review-s5",
      title: "Set 5: The Final Exam",
      questions: [
        { type: "order", q: "Construct a complex sentence:", words: ["My", "sister", "never", "eats", "breakfast", "on", "Sundays."], a: "My sister never eats breakfast on Sundays." },
        { type: "match",
          q: "Ultimate Grammar Match",
          pairs: [
            { left: "I am", right: "Doctor" },
            { left: "I work", right: "In a hospital" },
            { left: "I live", right: "In London" }
          ],
          a: "completed"
        },
        { type: "input", q: "Complete: I like tennis but I ___ (negative) play well.", a: "don't" },
        { type: "mc", q: "Choose the correct question:", options: ["What time do you start?", "What time does you start?", "What time you start?"], a: "What time do you start?" },
        { type: "blank", q: "My father's wife is my ___.", a: "mother" },
        { type: "order", q: "Ordena:", words: ["Where", "does", "your", "brother", "work?"], a: "Where does your brother work?" },
        { type: "mc", q: "She goes to the gym ___ Tuesdays.", options: ["on", "at", "in"], a: "on" },
        { type: "match",
          q: "Pronouns",
          pairs: [
            { left: "I -> My", right: "Mine" },
            { left: "You -> Your", right: "Yours" },
            { left: "She -> Her", right: "Hers" }
          ],
          a: "completed"
        },
        { type: "input", q: "Write the missing word: I wake ___ at 7:00.", a: "up" },
        { type: "order", q: "CONGRATULATIONS!", words: ["You", "are", "ready", "for", "Module", "Two!"], a: "You are ready for Module Two!" }
      ]
    }
  ]
};